import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './PoweredBy.scss';
import logo from '../../images/logo.svg';

const PoweredBy = ({ className }) => (
  <div className={cx(styles.container, className)}>
    <div className={styles.text} data-e2e="taker-powered-by">
      Powered by
    </div>
    <a href="https://nextiva.com" target="_blank">
      <img src={logo} className={styles.icon} />
    </a>
  </div>
);

PoweredBy.propTypes = {
  className: PropTypes.string,
};

PoweredBy.defaultProps = {
  className: '',
};

export default PoweredBy;
